<template>
    <v-dialog 
      v-model="dialog"
      @click:outside="$emit('update:activated', false)"
      max-width="900" 
      scrollable
    >
      <v-card>
        <v-card-title class="headline font-weight-bold">{{'Selecionar ' + tipo + ':'}}</v-card-title>
        <v-row align="center" no-gutters>
          <v-col cols="12">
            <v-text-field
              v-show="!loading"
              v-model="search"
              append-icon="mdi-magnify"
              class="mx-10 py-4"
              label="Procurar"
              hide-details
              single-line
            />
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="itemsTable(tipo)"
              :items-per-page="itemsPerPage"
              :search.sync="search"
              :page.sync="currentPage"
              :loading="loading"
              :hide-default-header="loading"
              :hide-default-footer="loading"
              no-data-text="Nenhum registro disponível"
              no-results-text="Nenhum registro correspondente encontrado"
              :mobile-breakpoint="0"
            >
              <template v-slot:item="row">
                <tr @click="selecionarCMU(row.item)">
                  <td class="button cursor-pointer" style="max-width: 70px"> {{ row.item.id }} </td>
                  <td class="button cursor-pointer" style="max-width: 220px">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                      <div class="text-truncate" v-bind="attrs" v-on="on">
                        {{ row.item.nome }}
                      </div>
                      </template>
                      <span>{{ row.item.nome }}</span>
                    </v-tooltip>
                  </td>
                  <td class="button cursor-pointer text-no-wrap"> {{ row.item.usuario.nome }} </td>
                  <td class="button cursor-pointer">
                    {{ formatData(row.item.created) }}
                  </td>
                  <td class="button cursor-pointer">
                    {{ formatData(row.item.modified) }}
                  </td>
                </tr>
              </template>
              <template v-slot:[`footer.page-text`]>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" v-bind="attrs" @click="loadData(tipo)" v-on="on">mdi-refresh</v-icon>
                  </template>
                  <span>Clique aqui para recarregar os relatórios</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </template>
  
<script>

import CmuService from '@/services/parametrosComCa/CmuService.js';
import NormasTecnicasService from '@/services/parametrosComCa/NormasTecnicasService.js'
import CadernosServicosService from '@/services/parametrosComCa/CadernosServicosService.js'
  
  export default {
    props: {
      activated: {
        type: Boolean,
        required: true
      },
      tipo: {
        type: String,
        required: true
      }
    },
  
    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      headers: [
        {
          text: "#",
          value: "id"
        },
        {
          text: "Nome",
          value: "nome"
        },
        {
          text: "Usuário",
          value: "usuario"
        },
        {
          text: "Criado",
          value: "criado"
        },
        {
          text: "Modificado",
          value: "modificado"
        },
      ],
      loading: false,
      cmu: [],
      normasTecnicas: [],
      cadernoServicos: [],
    }),
  
    computed: {
      dialog() {
        return this.activated;
      },
    },
  
    created() {
        this.getAllCmu();
        this.getNormasTecnicas();
        this.getCadernoServicos();
    },
  
    methods: {

      itemsTable(type) {

        var items = [];

        if (type === 'CMU') {

          items = this.cmu;

        } else if (type === 'Normas Técnicas') {

          items = this.normasTecnicas;

        } else if (type === 'Caderno de Serviços') {

          items = this.cadernoServicos;
        }

        return items;
      },

      selecionarCMU(cmu) {
        const data = {id: cmu.id, nome: cmu.nome};
        this.$emit("selected", data);
  
        setTimeout(() => { this.search = "" }, 500);
      },

      formatData(date) {

        return new Date(date).toLocaleString();
      },

      loadData(type) {

        if (type === 'CMU') {

          this.getAllCmu();

        } else if (type === 'Normas Técnicas') {

          this.getNormasTecnicas();

        } else if (type === 'Caderno de Serviços') {

          this.getCadernoServicos();
        }
      },

      getAllCmu() {
        this.cmu = [];
        this.loading = true;

        CmuService.getAllValoresUnitarios()
        .then(response => {
          response.data.valores.forEach(element => {
            this.cmu.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario,
              created: element.created,
              modified: element.modified,
            });
          });
        })
        .catch((error) => this.$toast.error("Erro ao recuperar consultas", {position: "topRight"}))
        .finally(() => this.loading = false);
      },

      getNormasTecnicas() {
        this.normasTecnicas = [];
        this.loading = true;

        NormasTecnicasService.getAllNormasTecnicas()
        .then(response => {
          response.data.normas.forEach(element => {
            this.normasTecnicas.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario,
              created: element.created,
              modified: element.modified,
            });
          });
        })
        .catch((error) => this.$toast.error("Erro ao recuperar consultas", {position: "topRight"}))
        .finally(() => this.loading = false);
      },

      getCadernoServicos() {
        this.cadernoServicos = [];
        this.loading = true;

        CadernosServicosService.getCadernosServicos()
        .then(response => {
          response.data.cadernos.forEach(element => {
            this.cadernoServicos.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario,
              created: element.created,
              modified: element.modified,
            });
          });
        })
        .catch((error) => this.$toast.error("Erro ao recuperar consultas", {position: "topRight"}))
        .finally(() => this.loading = false);
      }
    }
  };
  </script>
  
  <style scoped>
  .cursor-pointer:hover {
    cursor: pointer;
  }
  </style>